@use '../../../../../../styles/Colors.scss' as Colors;
@use '../../../../../../styles/Constants.scss' as Constants;

.label {
	color: Colors.$col-greyFontLight;
	padding: Constants.$val-spacing-s;
	padding-left: 0;
}

.value {
	padding-left: Constants.$val-spacing-s;
}

.status-value {
	padding-left: Constants.$val-spacing-s;
	padding-top: Constants.$val-spacing-s;
	padding-bottom: Constants.$val-spacing-l;
}
